import { AccountingOverview as AccountingOverviewView } from '@layerfi/components'
import { useNavigate } from 'react-router-dom'

import './styles.scss'

import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const AccountingOverview = () => {
  const navigate = useNavigate()
  return (
    <AccountingLayout>
      <AccountingOverviewView
        onTransactionsToReviewClick={() => {
          navigate('../bank-transactions')
        }}
      />
    </AccountingLayout>
  )
}
